export enum Currency {
  USD = 'USD',
  EUR = 'EUR',
  CHF = 'CHF',
  GBP = 'GBP',
}

export enum CurrencySymbol {
  USD = '$',
  EUR = '€',
  CHF = '₣',
  GBP = '£',
}

export const CURRENCY_SYMBOL_MAP: Record<Currency, CurrencySymbol> = {
  [Currency.USD]: CurrencySymbol.USD,
  [Currency.EUR]: CurrencySymbol.EUR,
  [Currency.CHF]: CurrencySymbol.CHF,
  [Currency.GBP]: CurrencySymbol.GBP,
};
